var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpringBootIcon = function SvgSpringBootIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6CB52D",
    clipPath: "url(#spring_boot_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.424 7.299a17.4 17.4 0 0 1-2.14 3.745C35.656 7.348 30.583 5 24.984 5 13.987 5 5 13.937 5 24.975c0 5.767 2.467 10.959 6.381 14.625l.743.664a19.87 19.87 0 0 0 12.852 4.697c10.502 0 19.153-8.195 19.896-18.54.594-5.023-.932-11.453-3.449-19.122m-27.15 32.47c-.574.743-1.644.822-2.388.247-.743-.574-.822-1.645-.247-2.388.574-.743 1.645-.822 2.388-.247.703.574.822 1.645.247 2.388m27.03-5.975c-4.904 6.55-15.447 4.33-22.165 4.657 0 0-1.198.079-2.388.248 0 0 .456-.209 1.03-.417 4.737-1.644 6.967-1.981 9.85-3.458 5.4-2.764 10.79-8.818 11.87-15.08-2.06 6.014-8.323 11.206-14.01 13.307-3.914 1.446-10.959 2.843-10.959 2.843l-.287-.168C9.469 33.378 9.3 22.994 18.04 19.654c3.834-1.486 7.46-.663 11.622-1.644 4.41-1.03 9.522-4.33 11.573-8.65 2.29 6.965 5.093 17.756.07 24.434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.274 39.769c-.575.743-1.645.822-2.388.247-.743-.574-.822-1.645-.248-2.388.575-.743 1.645-.822 2.388-.247.704.574.823 1.644.248 2.388"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spring_boot_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h40v40H5z"
  })))));
};
export default SvgSpringBootIcon;